import { render, staticRenderFns } from "./ShippingAttachments.vue?vue&type=template&id=4075b17a"
import script from "./ShippingAttachments.vue?vue&type=script&lang=js"
export * from "./ShippingAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports